<template>
  <div class="introduction_page">
    <div class="head_box">
      <div class="head_top">
        <img class="img" src="../../static/images/logoNew.png" alt="">
        <span class="text">业务定制系统</span>
      </div>
      <div class="head_content">
        <img class="img1" src="../../static/images/saasIntroduction/img1.png" alt="">
        <div class="content_card">
          <p class="title">电子签约业务定制系统</p>
          <div class="tip">
            以君子签电子合同签约系统为基础，区块链技术为核心，可根据企业实际需求灵活适配业务场景，从签约流程到数据管理实现全链路自定义。前端服务可与网站、公众号等整合集成，后台电子签约管理系统支持多账号管理、权限设置及数据导出，并支持个性化的业务数据报表定制以满足企业所需。适合有一定个性化需求，但却没有开发能力的中小微企业使用。
          </div>
          <div class="btn">
            <div class="text">针对行业不同的业务场景，提供适合自身情况的专属业务定制系统</div>
            <el-button style="width: 200px" type="primary" @click="applyFn">{{ywtApplyStatus === 0 ? '审核中' : '申请开通'}}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="main_box">
      <ul class="list_ul">
        <li class="list_li">
          <p class="btn_class">双方录入</p>
          <span>可按需配置电子合同模板，合同模板支持单、双方录入签约信息，同时支持针对签约方身份信息核验、签署意愿认证等。从模板创建到签约全流程无缝衔接，用“零门槛自定义+智能合规校验”，让每个企业都能快速拥有专属电子合同“生产线”，高效又省心！</span>
        </li>
        <li class="list_li">
          <p class="btn_class">前置业务首页</p>
          <span>可根据用户需求自定义创建前置业务首页，集业务展示、分类浏览、电子合同签署、费用支付为一体，灵活多变，操作简单。快速生成“业务展示+签约支付”一站式入口，用极简操作实现个性化业务门户自由，让每个企业都能拥有会“说话”的专属数字前台！</span>
        </li>
        <li class="list_li">
          <p class="btn_class">批量业务发起</p>
          <span>支持业务模板批量发起，多个业务模板相同变量一次录入，全模板可用，无需重复填写，省时省力。业务场景自由适配，一次操作全模板生效，用极简交互实现“填一次，用百次”的省心体验，大幅提升多模板处理效率，让企业流程管理更轻松！</span>
        </li>
        <li class="list_li">
          <p class="btn_class">业务模板管理</p>
          <span>通过可视化界面即可自由搭建匹配业务流程的模板体系——从合同正文内容、变量规则到审批流程嵌入、签约设置，全模块支持自定义配置，像拼搭专属“业务流程图”一样，轻松将纸质流程转化为数字化模板。</span>
        </li>
      </ul>
      <div class="main_img">
        <img class="img2" src="../../static/images/saasIntroduction/img2.png" alt="">
        <img class="img2" src="../../static/images/saasIntroduction/img3.png" alt="">
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="introductionVisible" width="30%" :show-close="false">
      <p>请联系企业管理员申请开通。</p>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="introductionVisible = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {isInDingTalk} from "../../assets/js/utils/ding-env";
  import {ApiMethods} from "../../assets/js/http-serve/http-methods";
  import {mapGetters} from "vuex";
  import {getCorpToken} from "../../assets/js/http-serve/corp/common";

  export default {
    name: "introductionPage",
    layout: "headandfullpage",
    data() {
      return {
        ywtApplyStatus: null,
        introductionVisible: false,

      }
    },
    computed: {
      ...mapGetters(["allAuthUser"]),
      accountInfoVO() {
        if (this.allAuthUser && this.allAuthUser.accountInfoVO) {
          return this.allAuthUser.accountInfoVO;
        }
        return {};
      },
      currentUser() {
        return this.$store.getters.currentAuthUser;
      },
    },
    mounted() {
      this.ywtStatusFn()
    },
    methods: {
      async ywtStatusFn() {
        let res = '';
        if (this.$route.query.corpUserId) {
          let result = await getCorpToken(item.corpUserId);
          res = await ApiMethods.ProfileController.ywtUserActivateStatus({_ctToken: result.data});
        } else {
          res = await ApiMethods.ProfileController.ywtActivateStatus();
        }
        this.ywtApplyStatus = res.data;
        if (res.data === 1) {
          await this.$router.replace({
            path: '/ywtRelated/guidancePage',
            query: {
              status: res.data,
              corpUserId: this.$route.query.corpUserId
            }
          })
        }
      },
      //申请开通
      applyFn() {
        if (this.ywtApplyStatus === 0) {
          this.$message.warning('正在审核中，请耐心等待')
        } else if (isInDingTalk) {
          return false;
        } else if (this.accountInfoVO.identityAuth != 1) {
          this.$confirm(
            "您的账号还未完成实名认证，无法使用完整功能！",
            "提示",
            {
              confirmButtonText: "去认证",
              cancelButtonText: "以后再说",
              type: "warning"
            }
          )
            .then(() => {
              this.gotoAuth();
            })
            .catch(() => {
            });
        } else {
          this.activateYwtSystemFn();
        }
      },
      gotoAuth() {
        if (this.$store.getters.authUser.userType === 0) {
          this.$router.push('/auth/personalIdentityAuth');
        } else {
          this.$router.push('/auth/authGuide');
        }
      },
      //开通ywt
      activateYwtSystemFn() {
        if (this.$route.query.corpUserId) {
          this.introductionVisible = true;
        } else {
          ApiMethods.ProfileController.ywtActivateApplication().then(res => {
            if (res.success) {
              this.$message.success('申请成功');
              this.ywtStatusFn();
              // this.$router.push({
              //   path:  '/ywtRelated/guidancePage',
              //   query: {
              //     status: res.data,
              //     corpUserId: this.$route.query.corpUserId
              //   }
              // })
            } else {
              this.$message.error(res.description);
            }
          })
        }
      },
    }
  }
</script>

<style scoped lang="less">
  .introduction_page {
    padding: 30px;

    .main_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px 0;

      .list_ul {
        width: 55%;

        .list_li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          border-radius: 6px;
          background-color: #d1d1d1;
          margin-bottom: 20px;

          .btn_class {
            flex-shrink: 0;
            width: 150px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border-radius: 10px;
            background-color: #ec1c1c;
            color: #ffffff;
            margin-right: 20px;
          }
        }
      }

      .main_img {
        width: 40%;
        flex-shrink: 0;

        .img2 {
          max-height: 265px;
          margin-right: 20px;
        }
      }
    }

    .head_box {
      padding: 20px;

      .head_top {
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        margin-bottom: 20px;

        .img {
          max-height: 50px;
          margin-right: 20px;
        }

        .text {
          font-size: 28px;
          color: #ec1c1c;
          font-weight: bold;
        }
      }

      .head_content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .img1 {
          width: 200px;
          height: 200px;
          flex-shrink: 0;
          margin-right: 40px;
        }

        .content_card {
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
          border-radius: 5px;
          padding: 10px 30px;
          background-color: #ffffff;

          .title {
            font-weight: bold;
            font-size: 20px;
          }

          .tip {
            font-size: 16px;
            margin: 20px 0;
          }

          .btn {
            display: flex;
            justify-content: space-between;

            .text {
              padding: 10px 20px;
              background-color: #999999;
              border-radius: 4px;
              margin-right: 30px;
              font-size: 18px;
              color: #ffffff;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// pages/ywtRelated/introductionPage.vue